import update_type from "mock/updateType"


class Region {

    constructor(region) {
        const { id, type, systemId, word_def_id, word_id } = region
        
        this.end_time = Number(region.end).toFixed(3)
        this.start_time = Number(region.start).toFixed(3)
        this.type = type || "SILENCE"

        if (update_type) this.update_type = update_type
        if (word_id) this.word_id = word_id
        if (word_def_id) this.word_def_id = word_def_id

        if (!systemId)
            this.update_type = update_type.update
        else this.id = systemId
    }
}

export default Region